import { render, staticRenderFns } from "./VuelidateErrorExtractor.vue?vue&type=template&id=45278561&"
import script from "./VuelidateErrorExtractor.vue?vue&type=script&lang=js&"
export * from "./VuelidateErrorExtractor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports